import { $themeConfig } from '../theme.config';
import store from '@/store';

export default {
    init() {


        // set default styles
        let val = localStorage.getItem('theme'); // light, dark, system
        val = val || $themeConfig.theme;
        store.dispatch('toggleTheme', val);

        val = localStorage.getItem('menu'); // vertical, collapsible-vertical, horizontal
        val = val || $themeConfig.menu;
        store.dispatch('toggleMenu', val);

        val = localStorage.getItem('layout'); // full, boxed-layout
        val = val || $themeConfig.layout;
        store.dispatch('toggleLayout', val);

        val = localStorage.getItem('i18n_locale'); // en, it,

        val = val || $themeConfig.locale;

        const list = store.getters.getLanguagesList;
        const item = list.find((item) => item.code === val);
        if (item) {
            this.toggleLanguage(item);
        }

        val = localStorage.getItem('rtlClass'); // rtl, ltr
        val = val || $themeConfig.rtlClass;
        store.dispatch('toggleRTL', val);

        val = localStorage.getItem('animation'); // animate__fadeIn, animate__fadeInDown, animate__fadeInUp, animate__fadeInLeft, animate__fadeInRight, animate__slideInDown, animate__slideInLeft, animate__slideInRight, animate__zoomIn
        val = val || $themeConfig.animation;
        store.dispatch('toggleAnimation', val);

        val = localStorage.getItem('navbar'); // navbar-sticky, navbar-floating, navbar-static
        val = val || $themeConfig.navbar;
        store.dispatch('toggleNavbar', val);

        val = localStorage.getItem('semidark');
        val = val === 'true' ? true : $themeConfig.semidark;
        store.dispatch('toggleSemidark', val);
    },

    toggleLanguage(item) {

        let lang = null;
        if (item) {
            lang = item;
        } else {
            let code = store.getters.getLocale || null;
            if (!code) {
                code = localStorage.getItem('i18n_locale');
            }

            item = store.getters.getLanguagesList.find((d) => d.code === code);
            if (item) {
                lang = item;
            }
        }

        if (!lang) {
            lang = store.getters.getLanguagesList.find((d) => d.code === 'en');
        }

        store.dispatch('toggleLocale', lang.code);
        return lang;
    },

    changeAnimation(type = 'add') {
        if (store.getters.getThemeAnimation) {
            const eleanimation = document.querySelector('.animation');
            if (type === 'add') {
                eleanimation?.classList.add('animate__animated');
                eleanimation?.classList.add(store.getters.getThemeAnimation);
            } else {
                eleanimation?.classList.remove('animate__animated');
                eleanimation?.classList.remove(store.getters.getThemeAnimation);
            }
        }
    },
};
